import { BranchForm, BranchFormAnswer, FormAnswers } from '../../../types';
import { PreviousPage } from '../../Shared/FormContainer/FormContainer';

export const chronic_conditions = [
  'Constipation',
  'Dental Problems',
  'Diabetes',
  'Diarrhoea',
  'Ear Infection',
  'Epilepsy',
  'Eye Infection',
  'Heart Disease',
  'IBD',
  'Joint Problems',
  'Kidney Disease',
  'Liver Disease',
  'Obesity',
  'Pancreatitis',
  'Seizures',
  'Sensitive Stomach',
  'Skin & Coat Problems',
  'Struvite Stones',
  'Urinary Tract',
  'Vomiting'
] as const;
export type Question = {
  formId: string;
  question: BranchForm['Questions'][0];
  PetRecordId: string | null;
  defaultAnswer: BranchFormAnswer['AnswerOptionId'] | BranchFormAnswer['answer'] | null | undefined;
};

export type onQuestionSubmitType = ({ formId, questionId, petRecordId, answer }: { formId: string; questionId: string; petRecordId: string | null; answer: any }) => void;

export type FormQuestionsRender = {
  questions: Question[];
  currentPage: number;
  previousPage: PreviousPage;
  onQuestionSubmit: onQuestionSubmitType;
  formsAnswers: FormAnswers[];
};

export type FormRenderProps = {
  registerAs: string;
  question: BranchForm['Questions']['0'];
  onSubmit: (values: any) => void;
  previousPage: PreviousPage;
};
